let languagePage = {
    CN: {
      problem_feedback:"问题反馈",
      record:'记录',
      feedback_type:'反馈类型',
      feedback_content:'反馈内容',    
      upload_screenshots:'上传截图',
      contact_information:'联系信息',
      enter_your_email_address:'请输入您的邮件地址',
      submit:'提交',
      awaiting_reply:'待回复',
      already_reply:'已回复',
      feedback_record:'反馈记录',
      feedback_details:'反馈详情',
      no_data:'暂无记录',
      thank_you_for_your_feedback:'谢谢您的反馈',
      back:'返回',
      photo_quantity_limit_reminder:'图片最多添加4张',
      photo_format_restriction_reminder:'图片上传格式支持jpeg、jpg、png；其他不支持',
      photo_size_limit_reminder:'上传图片大小不能超过 5MB!',
      we_will_process:'我们将尽快处理，并将结果发送回您的电子邮件，请耐心等待',
      no_records_available_at_the_moment:'暂无记录',
      select_type:'请选择反馈类型后再提交',
      enter_your_email_for_us_to_contact_you:'输入邮箱，方便我们联系您',
      submission_successful:'提交成功',
      failed_to_load:'加载失败',
      please_enter_feedback_content_before_submitting:'请输入反馈内容后再提交',
      please_describe_your_issue_in_detail_so_we_can_assist_you_better:"请详细描述您遇到的问题，以便我们为您提供更好的帮助",
      please_enter_the_normal_email_format:'请输入正确的邮箱地址',
      network_anomaly:'网络异常',
      sure:'确定',
      cancel:'取消'
    },
    EN: {
        problem_feedback:"Problem Feedback",
        record:'Record',
        feedback_type:'Feedback Type',
        feedback_content:'Feedback Content',    
        upload_screenshots:'Upload Screenshots',
        contact_information:'Contact Information',
        enter_your_email_address:'enter your email address',
        submit:'Submit',
        awaiting_reply:'Pending Response',
        already_reply:'Replied',
        feedback_record:'Feedback Record',
        feedback_details:'Details',
        no_data:'No records',
        thank_you_for_your_feedback:'Thank you for your feedback',
        back:'Back',
        we_will_process:'We will process it as soon as possible and send the result back to your email, please be patient.',
        photo_quantity_limit_reminder:'Add up to 4 images',
        photo_format_restriction_reminder:'The image upload format supports JPEG jpg、png； Other not supported',
        photo_size_limit_reminder:'The size of the uploaded image cannot exceed 5MB!',
        no_records_available_at_the_moment:'No records available at the moment',
        select_type:'Please select a feedback type before submitting',
        enter_your_email_for_us_to_contact_you:'Enter your email for us to contact you',
        submission_successful:'Submission Successful',
        failed_to_load:'Failed to load',
        please_enter_feedback_content_before_submitting:'Please enter feedback content before submitting',
        please_describe_your_issue_in_detail_so_we_can_assist_you_better:"Please describe your issue in detail so we can assist you better",
        please_enter_the_normal_email_format:'Please enter the correct email addresst',
        network_anomaly:'Network error, please try again!',
        sure:'confirm',
        cancel:'cancel'
    },
    HK:{
      problem_feedback:"問題反饋",
      record:'紀錄',
      feedback_type:'反饋類型',
      feedback_content:'反饋內容',    
      upload_screenshots:'上傳截圖',
      contact_information:'聯繫方式',
      enter_your_email_address:'輸入郵箱，方便我們聯繫您',
      select_type:'請選擇反饋類型後再提交',
      please_enter_feedback_content_before_submitting:'請輸入反饋內容後再提交',
      please_describe_your_issue_in_detail_so_we_can_assist_you_better:"請輸入聯繫方式後再提交",
      please_enter_the_normal_email_format:'請輸入徵求的郵箱地址',
      submit:'提交',
      awaiting_reply:'待回覆',
      already_reply:'已回覆',
      feedback_record:'紀錄',
      feedback_details:'詳細',
      no_data:'暫無記錄',
      thank_you_for_your_feedback:'谢谢您的反馈',
      back:'返回',
      photo_quantity_limit_reminder:'（不超過4張）',
      photo_format_restriction_reminder:'图片上传格式支持jpeg、jpg、png；其他不支持',
      photo_size_limit_reminder:'上传图片大小不能超过 5MB!',
      no_records_available_at_the_moment:'暫無記錄',
      enter_your_email_for_us_to_contact_you:'輸入郵箱，方便我們聯繫您',
      submission_successful:'提交成功',
      failed_to_load:'加載失敗',
      network_anomaly:'網絡異常',
      sure:'确定',
      cancel:'取消'
    },
    ES:{
      problem_feedback:"problema",
      record:'Registro',
      feedback_type:'Tipo de comentario',
      feedback_content:'Contenido del comentario',    
      upload_screenshots:'Subir captura de pantalla',
      contact_information:'Información de contacto',
      enter_your_email_address:'Ingrese su correo para contactarlo',
      submit:'Presentación',
      awaiting_reply:'Pendiente de respuesta',
      already_reply:'Respondido',
      feedback_record:'Registros',
      feedback_details:'Detalles',
      no_data:'Sin registros',
      thank_you_for_your_feedback:'Gracias por sus comentarios',
      back:'Volver',
      photo_quantity_limit_reminder:'(Hasta 4 imágenes)',
      photo_format_restriction_reminder:'图片上传格式支持jpeg、jpg、png；其他不支持',
      photo_size_limit_reminder:'上传图片大小不能超过 5MB!',
      no_records_available_at_the_moment:'Sin registros',
      select_type:'Seleccione un tipo de comentario antes de enviar',
      enter_your_email_for_us_to_contact_you:'Ingrese su correo para contactarlo',
      submission_successful:'Envío exitoso',
      failed_to_load:'Error de carga',
      please_enter_feedback_content_before_submitting:'Ingrese el contenido del comentario antes de enviar',
      please_describe_your_issue_in_detail_so_we_can_assist_you_better:"Describa su problema en detalle para que podamos ayudarle mejor",
      please_enter_the_normal_email_format:'Introduzca la dirección de correo electrónico correcta',
      network_anomaly:'Anomalía de red',
      sure: 'Confirmar',
      cancel: 'Cancelar'
      
    },
    PT:{
      problem_feedback:"problemas",
      record:'Registros',
      feedback_type:'Tipo de feedback',
      feedback_content:'Conteúdo do feedback',    
      upload_screenshots:'Enviar captura de tela',
      contact_information:'Informações de contato',
      enter_your_email_address:'Insira seu e-mail para contato',
      submit:'submeter',
      awaiting_reply:'Aguardando resposta',
      already_reply:'Respondido',
      feedback_record:'Registros',
      feedback_details:'Detalhes',
      no_data:'Nenhum registro',
      thank_you_for_your_feedback:'Obrigado pelo seu feedback',
      back:'retorno',
      photo_quantity_limit_reminder:'(Até 4 imagens)',
      photo_format_restriction_reminder:'图片上传格式支持jpeg、jpg、png；其他不支持',
      photo_size_limit_reminder:'上传图片大小不能超过 5MB!',
      we_will_process:'我们将尽快处理，并将结果发送回您的电子邮件，请耐心等待',
      no_records_available_at_the_moment:'Nenhum registro',
      select_type:'Selecione um tipo de feedback antes de enviar',
      enter_your_email_for_us_to_contact_you:'Insira seu e-mail para contato',
      submission_successful:'Envio bem-sucedido',
      failed_to_load:'Falha ao carregar',
      please_enter_feedback_content_before_submitting:'Insira o conteúdo do feedback antes de enviar',
      please_describe_your_issue_in_detail_so_we_can_assist_you_better:"Descreva seu problema detalhadamente para melhor assistência",
      please_enter_the_normal_email_format:'Introduza o endereço de e-mail correcto',
      network_anomaly:'Erro de rede, tente novamente!',
      sure: 'Confirmar',
      cancel: 'Cancelar'
    },
    DE:{
        problem_feedback: "Problemrückmabe",
        record: "Verlauf",
        feedback_type: "Feedback-Kategorie",
        feedback_content: "Feedback-Inhalt", 
        upload_screenshots: "Screenshots hochladen",
        contact_information: "Kontaktdaten",
        enter_your_email_address: "E-Mail-Adresse eingeben",
        submit: "Einreichen",
        awaiting_reply: "Antwort ausstehend",
        already_reply: "Beantwortet",
        feedback_record: "Feedback-Historie",
        feedback_details: "Feedback-Details",
        no_data: "Keine Einträge",
        thank_you_for_your_feedback: "Vielen Dank für Ihr Feedback",
        back: "Zurück",
        photo_quantity_limit_reminder: "Maximal 4 Bilder",
        photo_format_restriction_reminder: "Akzeptierte Formate: JPEG/JPG/PNG",
        photo_size_limit_reminder: "Maximal 5 MB pro Bild",
        we_will_process: "Bearbeitung erfolgt umgehend - Ergebnis erhalten Sie per E-Mail",
        no_records_available_at_the_moment: "Aktuell keine Einträge",
        select_type: "Bitte Feedback-Kategorie auswählen",
        enter_your_email_for_us_to_contact_you: "Kontakt-E-Mail (optional)",
        submission_successful: "Erfolgreich übermittelt",
        failed_to_load: "Ladefehler",
        please_enter_feedback_content_before_submitting: "Bitte Feedback-Inhalt eingeben",
        please_describe_your_issue_in_detail_so_we_can_assist_you_better: "Bitte Problembeschreibung detailliert angeben",
        please_enter_the_normal_email_format: "Ungültiges E-Mail-Format",
        network_anomaly:'Netzwerkanomalie',
        sure: 'Bestätigen',
        cancel: 'Abbrechen'
    },
    FR:{
      problem_feedback:"Feedback",
      record:'Enregistrement',
      feedback_type:'Type de feedback',
      feedback_content:'Contenu du feedback',    
      upload_screenshots:"Télécharger une capture d'écran",
      contact_information:'Informations de contact',
      enter_your_email_address:'Veuillez entrer votre adresse mail',
      submit:'Soumettre',
      awaiting_reply:'En attente de réponse',
      already_reply:'Répondu',
      feedback_record:'Enregistrements',
      feedback_details:'Détails',
      no_data:"Aucun enregistrement",
      thank_you_for_your_feedback:'Merci pour votre feedback',
      back:'Retour',
      photo_quantity_limit_reminder:"Images ajouter jusqu'à 4",
      photo_format_restriction_reminder:"Le format de téléchargement des images prend en charge JPEG, jpg、png； Autres non supportés",
      photo_size_limit_reminder:"La taille de l'image téléchargée ne peut pas dépasser 5mb!",
      we_will_process:"Nous traiterons le plus rapidement possible et vous enverrons les résultats par e - mail, soyez patient",
      no_records_available_at_the_moment:"Pas encore d'enregistrement",
      select_type:'Sélectionnez un type de feedback avant de soumettre',
      enter_your_email_for_us_to_contact_you:'Entrez votre e-mail pour contact',
      submission_successful:'Soumission réussie',
      failed_to_load:'Échec du chargement',
      please_enter_feedback_content_before_submitting:'Remplissez le contenu du feedback avant de soumettre',
      please_describe_your_issue_in_detail_so_we_can_assist_you_better:"Beschreiben Sie Ihr Problem detailliert, damit wir helfen können",
      please_enter_the_normal_email_format:'Veuillez entrer une adresse e - mail correcte',
      network_anomaly:'Netzwerkanomalie',
      sure: 'Confirmer',
      cancel: 'Annuler'
    },
    TH:{
      problem_feedback: "การรายงานปัญหา",
      record: "บันทึก",
      feedback_type: "ประเภทความคิดเห็น",
      feedback_content: "เนื้อหาความคิดเห็น", 
      upload_screenshots: "อัปโหลดภาพหน้าจอ",
      contact_information: "ข้อมูลติดต่อ",
      enter_your_email_address: "กรุณากรอกอีเมลของคุณ",
      submit: "ส่งข้อมูล",
      awaiting_reply: "รอการตอบกลับ",
      already_reply: "ตอบกลับแล้ว",
      feedback_record: "ประวัติการแจ้งปัญหา",
      feedback_details: "รายละเอียดความคิดเห็น",
      no_data: "ไม่มีข้อมูลในขณะนี้",
      thank_you_for_your_feedback: "ขอบคุณสำหรับความคิดเห็น",
      back: "ย้อนกลับ",
      photo_quantity_limit_reminder: "เพิ่มรูปได้สูงสุด 4 ภาพ",
      photo_format_restriction_reminder: "รองรับรูปแบบไฟล์: JPEG/JPG/PNG เท่านั้น",
      photo_size_limit_reminder: "ขนาดรูปไม่เกิน 5 MB!",
      we_will_process: "ระบบกำลังดำเนินการ กรุณาตรวจสอบผลลัพธ์ทางอีเมล",
      no_records_available_at_the_moment: "ไม่มีข้อมูลในขณะนี้",
      select_type: "กรุณาเลือกประเภทก่อนส่งข้อมูล",
      enter_your_email_for_us_to_contact_you: "อีเมลสำหรับติดต่อกลับ (ไม่จำเป็น)",
      submission_successful: "ส่งข้อมูลสำเร็จ",
      failed_to_load: "โหลดข้อมูลล้มเหลว",
      please_enter_feedback_content_before_submitting: "กรุณากรอกเนื้อหาความคิดเห็น",
      please_describe_your_issue_in_detail_so_we_can_assist_you_better: "กรุณาอธิบายปัญหาให้ละเอียด เพื่อการแก้ไขที่ตรงจุด",
      please_enter_the_normal_email_format: "รูปแบบอีเมลไม่ถูกต้อง",
      network_anomaly:'ข้อผิดพลาดของเครือข่าย',
      sure: 'ยืนยัน',
      cancel: 'ยกเลิก'
    },
    AR:{
      problem_feedback: "الإبلاغ عن مشكلة",
      record: "السجل",
      feedback_type: "نوع الملاحظة",
      feedback_content: "محتوى الملاحظات", 
      upload_screenshots: "رفع لقطات الشاشة",
      contact_information: "معلومات الاتصال",
      enter_your_email_address: "يرجى إدخال البريد الإلكتروني",
      submit: "إرسال",
      awaiting_reply: "بانتظار الرد",
      already_reply: "تم الرد",
      feedback_record: "سجل البلاغات",
      feedback_details: "تفاصيل الملاحظة",
      no_data: "لا توجد بيانات حالياً",
      thank_you_for_your_feedback: "شكراً على ملاحظاتك",
      back: "رجوع",
      photo_quantity_limit_reminder: "الحد الأقصى 4 صور",
      photo_format_restriction_reminder: "صيغ الملفات المدعومة: JPEG/JPG/PNG فقط",
      photo_size_limit_reminder: "الحجم الأقصى للصورة 5 ميجابايت!",
      we_will_process: "جاري المعالجة، سيصلكم النتيجة عبر البريد الإلكتروني",
      no_records_available_at_the_moment: "لا توجد سجلات متاحة",
      select_type: "يرجى اختيار النوع قبل الإرسال",
      enter_your_email_for_us_to_contact_you: "البريد الإلكتروني للتواصل (اختياري)",
      submission_successful: "تم الإرسال بنجاح",
      failed_to_load: "فشل التحميل",
      please_enter_feedback_content_before_submitting: "يرجى إدخال محتوى الملاحظات",
      please_describe_your_issue_in_detail_so_we_can_assist_you_better: "يرجى وصف المشكلة بالتفصيل لمساعدتكم بشكل أفضل",
      please_enter_the_normal_email_format: "صيغة البريد الإلكتروني غير صحيحة",
      network_anomaly:'شبكة غير طبيعية',
      sure: 'تأكيد',
      cancel: 'إلغاء'
    },
    IT:{
      problem_feedback: "Segnalazione problemi",
      record: "Cronologia",
      feedback_type: "Tipologia feedback",
      feedback_content: "Contenuto feedback", 
      upload_screenshots: "Carica screenshot",
      contact_information: "Dati contatto",
      enter_your_email_address: "Inserisci indirizzo email",
      submit: "Invia",
      awaiting_reply: "In attesa di risposta",
      already_reply: "Risposta inviata",
      feedback_record: "Archivio segnalazioni",
      feedback_details: "Dettagli feedback",
      no_data: "Nessun dato disponibile",
      thank_you_for_your_feedback: "Grazie per il feedback",
      back: "Indietro",
      photo_quantity_limit_reminder: "Massimo 4 immagini",
      photo_format_restriction_reminder: "Formati supportati: JPEG/JPG/PNG",
      photo_size_limit_reminder: "Dimensione massima 5 MB",
      we_will_process: "Elaborazione in corso - riceverai gli esiti via email",
      no_records_available_at_the_moment: "Nessun record disponibile",
      select_type: "Seleziona tipologia prima dell'invio",
      enter_your_email_for_us_to_contact_you: "Email di contatto (opzionale)",
      submission_successful: "Invio completato",
      failed_to_load: "Errore di caricamento",
      please_enter_feedback_content_before_submitting: "Compilare il campo feedback",
      please_describe_your_issue_in_detail_so_we_can_assist_you_better: "Descrivere dettagliatamente il problema",
      please_enter_the_normal_email_format: "Formato email non valido",
      network_anomaly:'Anomalia di rete',
      sure: 'Conferma',
      cancel: 'Annulla'
    },
    VI:{
      problem_feedback: "Báo cáo sự cố",
      record: "Lịch sử",
      feedback_type: "Phân loại phản hồi",
      feedback_content: "Nội dung chi tiết", 
      upload_screenshots: "Tải lên ảnh chụp",
      contact_information: "Thông tin liên hệ",
      enter_your_email_address: "Địa chỉ email",
      submit: "Gửi biểu mẫu",
      awaiting_reply: "Đang chờ phản hồi",
      already_reply: "Đã nhận phản hồi",
      feedback_record: "Lưu trữ phản hồi",
      feedback_details: "Thông tin sự cố",
      no_data: "Không có dữ liệu",
      thank_you_for_your_feedback: "Cảm ơn đóng góp",
      back: "Trở lại",
      photo_quantity_limit_reminder: "Tối đa 4 hình ảnh",
      photo_format_restriction_reminder: "Định dạng: JPEG/JPG/PNG",
      photo_size_limit_reminder: "Dung lượng ≤5MB",
      we_will_process: "Đang xử lý - kết quả sẽ được thông báo qua email",
      no_records_available_at_the_moment: "Chưa có bản ghi",
      select_type: "Chọn phân loại trước khi gửi",
      enter_your_email_for_us_to_contact_you: "Email liên hệ (không bắt buộc)",
      submission_successful: "Gửi thành công",
      failed_to_load: "Lỗi tải dữ liệu",
      please_enter_feedback_content_before_submitting: "Vui lòng nhập nội dung",
      please_describe_your_issue_in_detail_so_we_can_assist_you_better: "Mô tả chi tiết sự cố",
      please_enter_the_normal_email_format: "Email không hợp lệ",
      network_anomaly:'Lỗi mạng, vui lòng thử lại!',
      sure: 'Xác nhận',
      cancel: 'Hủy'
    },
    ID:{
      problem_feedback: "Lapor Masalah",
      record: "Riwayat",
      feedback_type: "Jenis Feedback", 
      feedback_content: "Isi Laporan",
      upload_screenshots: "Unggah SS",
      contact_information: "Info Kontak",
      enter_your_email_address: "Email Anda",
      submit: "Kirim",
      awaiting_reply: "Menunggu",
      already_reply: "Sudah Dibalas",
      feedback_record: "Arsip Feedback",
      feedback_details: "Detail Laporan",
      no_data: "Tidak Ada Data",
      thank_you_for_your_feedback: "Terima Kasih",
      back: "Kembali",
      photo_quantity_limit_reminder: "Maks.4 gambar",
      photo_format_restriction_reminder: "Format: JPG/PNG",
      photo_size_limit_reminder: "Ukuran ≤5MB",
      we_will_process: "Sedang diproses...",
      no_records_available_at_the_moment: "Data Kosong",
      select_type: "Pilih Jenis",
      enter_your_email_for_us_to_contact_you: "Email (opsional)",
      submission_successful: "Terkirim",
      failed_to_load: "Gagal Muat",
      please_enter_feedback_content_before_submitting: "Harap isi konten",
      please_describe_your_issue_in_detail_so_we_can_assist_you_better: "Deskripsi detail",
      please_enter_the_normal_email_format: "Format email salah",
      network_anomaly:'Terjadi kesalahan jaringan, coba lagi!',
      sure: 'Konfirmasi',
      cancel: 'Batal'
    },
    ML:{
      problem_feedback: "Laporan Masalah",
      record: "Rekod Historikal", 
      feedback_type: "Jenis Maklum Balas",
      feedback_content: "Kandungan Terperinci",
      upload_screenshots: "Muat Naik Screenshot (SS)",
      contact_information: "Maklumat Perhubungan",
      enter_your_email_address: "Alamat Emel Anda",
      submit: "Hantar Laporan",
      awaiting_reply: "Menunggu Respons",
      already_reply: "Sudah Dibalas",
      feedback_record: "Arkib Maklum Balas",
      feedback_details: "Butiran Laporan",
      no_data: "Tiada Rekod",
      thank_you_for_your_feedback: "Terima Kasih Atas Maklum Balas",
      back: "Kembali ke Menu",
      photo_quantity_limit_reminder: "Had Maksimum: 4 Gambar",
      photo_format_restriction_reminder: "Format Fail: JPG/PNG",
      photo_size_limit_reminder: "Saiz Fail ≤5MB",
      we_will_process: "Dalam Proses (Status akan dikemas kini melalui emel)",
      no_records_available_at_the_moment: "Tiada Data Sedia Ada",
      select_type: "Pilih Jenis Laporan",
      enter_your_email_for_us_to_contact_you: "Emel Perhubungan (Pilihan)",
      submission_successful: "Penghantaran Berjaya",
      failed_to_load: "Gagal Memuatkan Data",
      please_enter_feedback_content_before_submitting: "Sila Isi Kandungan Laporan",
      please_describe_your_issue_in_detail_so_we_can_assist_you_better: "Sila Berikan Deskripsi Terperinci",
      please_enter_the_normal_email_format: "Format Emel Tidak Sah",
      network_anomaly:'Terjadi kesalahan jaringan, coba lagi!',
      sure: 'Sahkan',
      cancel: 'Batal'
    },
    JA:{
      problem_feedback: "不具合報告",
      record: "履歴一覧",
      feedback_type: "報告種別",
      feedback_content: "詳細内容", 
      upload_screenshots: "スクショ添付",
      contact_information: "連絡先情報",
      enter_your_email_address: "メールアドレス",
      submit: "報告する",
      awaiting_reply: "対応中",
      already_reply: "対応済み",
      feedback_record: "報告アーカイブ",
      feedback_details: "不具合詳細",
      no_data: "データなし",
      thank_you_for_your_feedback: "ご報告ありがとうございます",
      back: "戻る",
      photo_quantity_limit_reminder: "添付可能：最大4枚",
      photo_format_restriction_reminder: "形式：JPG/PNG",
      photo_size_limit_reminder: "容量上限：5MB",
      we_will_process: "受付完了（対応状況はメールで通知）",
      no_records_available_at_the_moment: "表示データがありません",
      select_type: "報告種別を選択",
      enter_your_email_for_us_to_contact_you: "連絡先メール（任意）",
      submission_successful: "送信完了",
      failed_to_load: "データ取得エラー",
      please_enter_feedback_content_before_submitting: "内容を入力してください",
      please_describe_your_issue_in_detail_so_we_can_assist_you_better: "具体的な状況をご記入ください",
      please_enter_the_normal_email_format: "メール形式が不正です",
      network_anomaly:'ネットワークエラー、再度お試しください！',
      sure: '確認',
      cancel: 'キャンセル'
    },
    KR:{
      problem_feedback: "오류 신고",
      record: "기록 보기", 
      feedback_type: "신고 유형",
      feedback_content: "상세 내용",
      upload_screenshots: "스크린샷 첨부",
      contact_information: "연락처 정보",
      enter_your_email_address: "이메일 주소",
      submit: "제출하기",
      awaiting_reply: "처리 대기",
      already_reply: "처리 완료",
      feedback_record: "신고 기록",
      feedback_details: "상세 내역",
      no_data: "데이터 없음",
      thank_you_for_your_feedback: "신고해 주셔서 감사합니다",
      back: "뒤로",
      photo_quantity_limit_reminder: "최대 4장 첨부 가능",
      photo_format_restriction_reminder: "파일 형식: JPG/PNG",
      photo_size_limit_reminder: "최대 용량: 5MB",
      we_will_process: "접수 완료(처리 현황 이메일 통보)",
      no_records_available_at_the_moment: "표시할 데이터가 없습니다",
      select_type: "신고 유형 선택",
      enter_your_email_for_us_to_contact_you: "연락용 이메일(선택)",
      submission_successful: "제출 성공",
      failed_to_load: "데이터 불러오기 실패",
      please_enter_feedback_content_before_submitting: "내용을 입력해 주세요",
      please_describe_your_issue_in_detail_so_we_can_assist_you_better: "구체적인 상황을 설명해 주세요",
      please_enter_the_normal_email_format: "이메일 형식이 올바르지 않습니다",
      network_anomaly:'네트워크 오류, 다시 시도해 주세요!',
      sure: '확인',
      cancel: '취소'
    },
    TR:{
      problem_feedback:"Sorun Geri Bildirimi",
      record:'Kayıt',
      feedback_type:'Geri Bildirim Türü',
      feedback_content:'Geri Bildirim İçeriği',
      upload_screenshots:'Ekran Görüntüsü Yükle',
      contact_information:'İletişim Bilgileri',
      enter_your_email_address:'Lütfen e-posta adresinizi girin',
      submit:'Gönder',
      awaiting_reply:'Yanıt Bekleniyor',
      already_reply:'Yanıtlandı',
      feedback_record:'Geri Bildirim Kaydı',
      feedback_details:'Geri Bildirim Detayları',
      no_data:'Kayıt Bulunamadı',
      thank_you_for_your_feedback:'Geri Bildiriminiz İçin Teşekkür Ederiz',
      back:'Geri',
      photo_quantity_limit_reminder:'En fazla 4 adet fotoğraf eklenebilir',
      photo_format_restriction_reminder:'Desteklenen formatlar: jpeg, jpg, png',
      photo_size_limit_reminder:'Fotoğraf boyutu 5MB\'ı geçemez!',
      we_will_process:'En kısa sürede işleme alıp sonucu e-posta ile bildireceğiz',
      no_records_available_at_the_moment:'Henüz kayıt bulunmuyor',
      select_type:'Lütfen önce geri bildirim türünü seçin',
      enter_your_email_for_us_to_contact_you:'Bize ulaşmamız için e-posta adresinizi girin',
      submission_successful:'Başarıyla Gönderildi',
      failed_to_load:'Yükleme Başarısız',
      please_enter_feedback_content_before_submitting:'Lütfen göndermeden önce geri bildirim içeriği girin',
      please_describe_your_issue_in_detail_so_we_can_assist_you_better:"Lütfen sorununuzu detaylıca açıklayın",
      please_enter_the_normal_email_format:'Lütfen geçerli bir e-posta adresi girin',
      network_anomaly:'Ağ Hatası',
      sure: 'Onayla',
      cancel: 'İptal'
    },
    BN:{
      problem_feedback:"সমস্যা প্রতিক্রিয়া",
      record:'রেকর্ড',
      feedback_type:'প্রতিক্রিয়া ধরন',
      feedback_content:'প্রতিক্রিয়া বিষয়বস্তু',
      upload_screenshots:'স্ক্রিনশট আপলোড করুন',
      contact_information:'যোগাযোগের তথ্য',
      enter_your_email_address:'আপনার ইমেইল ঠিকানা লিখুন',
      submit:'জমা দিন',
      awaiting_reply:'প্রতিক্রিয়ার জন্য অপেক্ষারত',
      already_reply:'প্রতিক্রিয়া করা হয়েছে',
      feedback_record:'প্রতিক্রিয়া রেকর্ড',
      feedback_details:'প্রতিক্রিয়া বিবরণ',
      no_data:'কোন ডেটা নেই',
      thank_you_for_your_feedback:'আপনার প্রতিক্রিয়ার জন্য ধন্যবাদ',
      back:'ফিরে যান',
      photo_quantity_limit_reminder:'সর্বাধিক ৪টি ছবি যোগ করা যাবে',
      photo_format_restriction_reminder:'jpeg/jpg/png ফরম্যাট সমর্থিত',
      photo_size_limit_reminder:'ছবির আকার 5MB এর বেশি হতে পারবে না!',
      we_will_process:'আমরা দ্রুত প্রক্রিয়া করে ফলাফল ইমেইলে পাঠাব',
      no_records_available_at_the_moment:'কোন রেকর্ড নেই',
      select_type:'জমা দিতে প্রথমে প্রতিক্রিয়া ধরন নির্বাচন করুন',
      enter_your_email_for_us_to_contact_you:'যোগাযোগের জন্য ইমেইল লিখুন',
      submission_successful:'জমা সফল হয়েছে',
      failed_to_load:'লোড ব্যর্থ',
      please_enter_feedback_content_before_submitting:'জমা দিতে প্রতিক্রিয়া লিখুন',
      please_describe_your_issue_in_detail_so_we_can_assist_you_better:"সমস্যার বিস্তারিত বর্ণনা করুন",
      please_enter_the_normal_email_format:'সঠিক ইমেইল ফরম্যাট লিখুন',
      network_anomaly:'নেটওয়ার্ক ত্রুটি',
      sure: 'নিশ্চিত করুন',
      cancel: 'বাতিল'
    },
    PK:{
      problem_feedback:"مسئلے کی رائے",
      record:'ریکارڈ',
      feedback_type:'رائے کی قسم',
      feedback_content:'رائے کا مواد',
      upload_screenshots:'سکرین شاٹ اپ لوڈ کریں',
      contact_information:'رابطے کی معلومات',
      enter_your_email_address:'اپنا ای میل ایڈریس درج کریں',
      submit:'جمع کروائیں',
      awaiting_reply:'جواب کا انتظار',
      already_reply:'جواب دیا جا چکا',
      feedback_record:'رائے کا ریکارڈ',
      feedback_details:'رائے کی تفصیلات',
      no_data:'کوئی ڈیٹا موجود نہیں',
      thank_you_for_your_feedback:'آپ کی رائے کا شکریہ',
      back:'واپس جائیں',
      photo_quantity_limit_reminder:'زیادہ سے زیادہ 4 تصویریں شامل کی جا سکتی ہیں',
      photo_format_restriction_reminder:'jpeg/jpg/png فارمیٹس سپورٹڈ',
      photo_size_limit_reminder:'تصویر کا سائز 5MB سے زیادہ نہ ہو!',
      we_will_process:'ہم جلد ازجلد آپ کے ای میل پر نتائج بھیج دیں گے',
      no_records_available_at_the_moment:'فی الحال کوئی ریکارڈ موجود نہیں',
      select_type:'رائے کی قسم منتخب کریں',
      enter_your_email_for_us_to_contact_you:'ہم سے رابطے کے لیے اپنا ای میل درج کریں',
      submission_successful:'جمع کروائی کامیاب',
      failed_to_load:'لوڈنگ ناکام',
      please_enter_feedback_content_before_submitting:'رائے کا مواد درج کریں',
      please_describe_your_issue_in_detail_so_we_can_assist_you_better:"مسئلے کی تفصیل بیان کریں",
      please_enter_the_normal_email_format:'درست ای میل ایڈریس درج کریں',
      network_anomaly:'نیٹ ورک خرابی',
      sure: 'تصدیق کریں',
      cancel: 'منسوخ کریں'
    }
  };
  export const getLangue = () => {
    // 获取我们设置存放在浏览器的localStorage 的语言类型
    let  language  = 'zh'
    if(getQueryVariable('lang')){
      language = getQueryVariable('lang');
    }
    // let languageCode = path.match(/^\/([a-z]{2})\//i)[1]; 
    // if (language == "ar") {
    //   // 阿拉伯语 展示顺序会相反，设置反向，使语言展示正常
    //   document.documentElement.setAttribute("dir", "rtl");
    //   // document.getElementById("app") &&
    //   //   document.getElementById("app").classList.add("ar");
    // }
   
    // zh  中文
    // en 英文
   
    let list = {
      zh: "CN",//中国
      fr:'FR',//法语
      en:'EN',//英语
      hk:'HK',//香港
      es:'ES',//西班牙
      pt:'PT',//葡萄牙
      de:"DE",//德国
      th:'TH',//泰国
      ar:"AR",//阿拉伯
      it:'IT',//意大利
      vi:'VI',//越南
      id:'ID',//印尼
      ml:'ML',//马来
      ja:'JA',//日本
      kr:'KR',//韩国
      tr:'TR',//土耳其
      bn:'BN',//孟加拉
      pk:'PK'//巴基斯坦
    };
    //假设能读取到浏览器设置的语言，就使用该语言 ，假设没有设置到浏览器任何语言类型，就默认使用英文
    if (list[language]) return languagePage[list[language]];
    return languagePage.EN;
  };
  function getQueryVariable(item)
  {
     var sValue = window.location.href.match(new RegExp("[\?\&]" + item + "=([^\&]*)(\&?)", "i"));
      return sValue ? sValue[1] : sValue;
  }


// WEBPACK FOOTER //
// ./src/utils/language.js